if (!customElements.get('guarantee-promise')) {
  customElements.define(
    'guarantee-promise',
    class GuaranteePromise extends HTMLElement {
      connectedCallback() {
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        // Final values are server-rendered, so reduced-motion visitors need
        // no work at all: content is visible and the numbers are correct.
        if (this.reducedMotion.matches) return;

        // Marks that JS is live — CSS only hides the reveal targets once
        // this class is present, so no-JS visitors always see the content.
        this.classList.add('gp-js');

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              this.classList.add('is-inview');
              this.startCountUps();
              this.observer.disconnect();
              this.observer = null;
            });
          },
          { threshold: 0.35 }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      startCountUps() {
        this.querySelectorAll('[data-count-to]').forEach((el) => {
          const target = parseInt(el.dataset.countTo.replace(/[^0-9]/g, ''), 10);
          if (!Number.isFinite(target) || target <= 0) return;

          const suffix = el.dataset.suffix || '';
          const useSeparators = el.dataset.countTo.length !== String(target).length;
          const format = (value) =>
            (useSeparators ? new Intl.NumberFormat().format(value) : String(value)) + suffix;

          const duration = 1200;
          let start = null;
          const step = (timestamp) => {
            if (start === null) start = timestamp;
            const progress = Math.min((timestamp - start) / duration, 1);
            const eased = 1 - Math.pow(1 - progress, 3);
            el.textContent = format(Math.round(target * eased));
            if (progress < 1) requestAnimationFrame(step);
          };
          requestAnimationFrame(step);
        });
      }
    }
  );
}
